import React from 'react';
import { AccountTypeNumber } from '~/types';
import Combobox from './primitives/Combobox';
import Accounts, { AccountModel } from '../../../views/Accounts';
import { t } from '../l10n/l10n';

const isUnavailable = (accountTypeNumber: AccountTypeNumber) =>
    accountTypeNumber === AccountTypeNumber.TotalFrom ||
    accountTypeNumber === AccountTypeNumber.Heading ||
    accountTypeNumber === AccountTypeNumber.HeadingBreak ||
    accountTypeNumber === AccountTypeNumber.TotalIntervals ||
    accountTypeNumber === AccountTypeNumber.SumAlpha;

interface Props {
    isBlockedForDirectEntries?: boolean;
    onCreated?: Function;
    hideSummary?: boolean;
    [x: string]: any;
    modalDraggable?: boolean;
    onAccountSelected?: (account: number) => void;
    showAllAccountTypes?: boolean;
    allowHeadingClick?: boolean;
}

export default function AccountCombobox({
    isBlockedForDirectEntries,
    onCreated,
    hideSummary = false,
    onAccountSelected,
    showAllAccountTypes = false,
    allowHeadingClick = false,
    ...props
}: Props) {
    return (
        <Combobox
            {...props}
            aria-label={t`MODAL_CHART_OF_ACCOUNTS_TITLE`}
            endpoint="/accounts"
            transform={(accounts: AccountModel[]) =>
                accounts
                    .filter(
                        account =>
                            account.access &&
                            (isBlockedForDirectEntries !== undefined
                                ? account.isBlockedForDirectEntries === isBlockedForDirectEntries
                                : true) &&
                            account.type &&
                            (showAllAccountTypes ? true : !isUnavailable(account.type.number))
                    )
                    .map(account => ({
                        data: account,
                        text: `${account.number} - ${account.name}`,
                        summary: hideSummary ? undefined : account.name,
                        value: account.number,
                    }))
            }
            transformDependencies={[isBlockedForDirectEntries]}
            onChange={account => {
                props.onChange?.(account); // invoke form system onChange handler
                onAccountSelected?.(account);
            }}
            modal={({ hide, onChange }) => (
                <Accounts
                    modalDraggable={props.modalDraggable}
                    onCreated={account => {
                        onCreated?.();
                        onChange(account.number, account, true);
                        onAccountSelected?.(account.number);
                        hide();
                    }}
                    onSelected={account => {
                        onChange(account.number, account);
                        onAccountSelected?.(account.number);
                        hide();
                    }}
                    selectedAccountNumber={props.value}
                    showAllAccountTypes={showAllAccountTypes}
                    allowHeadingClick={allowHeadingClick}
                />
            )}
            modalSize="sm"
            style={{ width: '150px' }}
        />
    );
}
